export const STATUS_LABELS = {
  pending:    'Bekliyor',
  assigned:   'Atandı',
  on_the_way: 'Yolda',
  started:    'Başladı',
  paused:     'Beklemede',
  completed:  'Tamamlandı',
  approved:   'Onaylandı',
  cancelled:  'İptal',
};

export const STATUS_COLORS = {
  pending:    'bg-slate-100 text-slate-700',
  assigned:   'bg-blue-100 text-blue-700',
  on_the_way: 'bg-yellow-100 text-yellow-700',
  started:    'bg-orange-100 text-orange-700',
  paused:     'bg-amber-100 text-amber-700',
  completed:  'bg-green-100 text-green-700',
  approved:   'bg-emerald-100 text-emerald-700',
  cancelled:  'bg-red-100 text-red-700',
};

export const STATUS_DOT = {
  pending:    'bg-slate-400',
  assigned:   'bg-blue-500',
  on_the_way: 'bg-yellow-500',
  started:    'bg-orange-500',
  paused:     'bg-amber-500',
  completed:  'bg-green-500',
  approved:   'bg-emerald-600',
  cancelled:  'bg-red-500',
};

export const PRIORITY_LABELS = {
  urgent: 'Acil',
  normal: 'Normal',
  low:    'Düşük',
};

export const PRIORITY_COLORS = {
  urgent: 'bg-red-100 text-red-700',
  normal: 'bg-blue-100 text-blue-700',
  low:    'bg-slate-100 text-slate-600',
};

export const PRIORITY_BORDER = {
  urgent: 'border-l-red-500',
  normal: 'border-l-blue-400',
  low:    'border-l-slate-300',
};

export const STATUS_BORDER = {
  pending:    'border-l-slate-400',
  assigned:   'border-l-blue-500',
  on_the_way: 'border-l-orange-500',
  started:    'border-l-yellow-400',
  paused:     'border-l-amber-500',
  completed:  'border-l-green-500',
  approved:   'border-l-emerald-600',
  cancelled:  'border-l-red-500',
};

// Backend job_pause_reason enum -> Türkçe etiket. Backend'de yeni bir
// değer eklenirse burada da eklenmeli — eklenmezse JobDetail'da raw enum
// string ('weather' gibi) görünür.
export const PAUSE_REASON_LABELS = {
  no_customer:      'Müşteri yok',
  waiting_parts:    'Parça bekleniyor',
  customer_request: 'Müşteri talebi',
  weather:          'Hava şartları',
  other:            'Diğer',
};

export const formatJobNumber = (n) => `JOB-${String(n).padStart(4, '0')}`;

export const ROLE_LABELS = {
  superadmin:  'Super Admin',
  admin:       'Yönetici',
  supervisor:  'Sorumlu',
  field_staff: 'Saha Personeli',
};
